import type { IPurchaserRepository } from "@src/domain/repositories/purchaser";
import type { PurchaserBrandAssociation } from "@src/domain/entities/purchaser";
import type { CreateBrandPurchaserAssociationDTO } from "@src/domain/dto/purchasers";

export class CreateBrandPurchaserAssociationUseCase {
  private readonly purchaserRepository: IPurchaserRepository;

  constructor(purchaserRepository: IPurchaserRepository) {
    this.purchaserRepository = purchaserRepository;
  }

  execute(
    params: CreateBrandPurchaserAssociationDTO,
  ): Promise<PurchaserBrandAssociation> {
    return this.purchaserRepository.createBrandPurchaserAssociation(params);
  }
}
